<div ngCollapsible [isOpen]="isOpen" [ngCollapseOptions]="options" class="collapsible-container">
  <ng-content select="[title]"></ng-content>
  <ng-content select="[content]"></ng-content>
</div>
